import React from 'react';
import PropTypes from 'prop-types';

import { StepLabel as MUIStepLabel } from '@material-ui/core';

export const StepLabel = props => <MUIStepLabel {...props} />;

StepLabel.propTypes = {
  StepIconComponent: PropTypes.elementType,
  StepIconProps: PropTypes.object,
  classes: PropTypes.object,
  error: PropTypes.bool,
  icon: PropTypes.node,
  optional: PropTypes.node
};

export default StepLabel;
